import { get } from "lodash";
import { useSelector } from "react-redux";

import {
  REQUEST_MASTER_COMMUNITY,
  REQUEST_CREATE_MASTER_COMMUNITY,
  SET_MASTER_COMMUNITY,
  SUCCESS_CREATE_MASTER_COMMUNITY,
  ERROR_GET_MASTER_COMMUNITY,
  ERROR_CREATE_MASTER_COMMUNITY,
  SET_MESSAGE_MASTER_COMMUNITY,
  SUCCESS_DELETE_MASTER_COMMUNITY,
  SUCCESS_UPDATE_MASTER_COMMUNITY,
  REQUEST_DELETE_MASTER_COMMUNITY,
  REQUEST_UPDATE_MASTER_COMMUNITY,
  ERROR_DELETE_MASTER_COMMUNITY,
  ERROR_UPDATE_MASTER_COMMUNITY,
} from "./communityActionTypes";

interface IState {
  busy: boolean;
  message: string;
  masterCommunity: any[];
}

const initialState: IState = {
  busy: false,
  message: "",
  masterCommunity: [],
};

const community = (state = initialState, action: Record<string, any>) => {
  switch (action.type) {
    case REQUEST_MASTER_COMMUNITY:
    case REQUEST_CREATE_MASTER_COMMUNITY:
    case REQUEST_DELETE_MASTER_COMMUNITY:
    case REQUEST_UPDATE_MASTER_COMMUNITY:
      return {
        ...state,
        busy: true,
        message: "",
      };

    case SET_MESSAGE_MASTER_COMMUNITY:
      return {
        ...state,
        message: "",
      };

    case SET_MASTER_COMMUNITY:
      return {
        ...state,
        busy: false,
        message: "",
        masterCommunity: action.payload,
      };

    case SUCCESS_CREATE_MASTER_COMMUNITY:
      // console.log(action.payload);
      return {
        ...state,
        busy: false,
        message: "",
        masterCommunity: [...state.masterCommunity, action.payload],
      };
    case SUCCESS_DELETE_MASTER_COMMUNITY:
      return {
        ...state,
        busy: false,
        message: "",
        masterCommunity: state.masterCommunity.filter(
          (tutorial) => get(tutorial, "_id") !== action.payload
        ),
      };

    case SUCCESS_UPDATE_MASTER_COMMUNITY:
      return {
        ...state,
        busy: false,
        message: "",
        masterCommunity: state.masterCommunity.map((mp) => {
          return get(mp, "_id") === action.payload._id ? action.payload : mp;
        }),
      };

    case ERROR_GET_MASTER_COMMUNITY:
    case ERROR_CREATE_MASTER_COMMUNITY:
    case ERROR_UPDATE_MASTER_COMMUNITY:
    case ERROR_DELETE_MASTER_COMMUNITY:
      return {
        ...state,
        busy: false,
        message:
          action.payload || "Something happened wrong try again after sometime",
      };
    default:
      return state;
  }
};

export default community;

export function useCommunityMaster() {
  return useSelector((state: Record<string, any>) => state.community);
}
